import React from 'react';

import {useTranslation} from 'react-i18next';

import {Button, ButtonVariant} from 'components/ui-kit/Button';
import {Modal} from 'components/ui-kit/Modal';

import {ModalContent, ModalMessage, ModalButtons} from './styled';

interface Props {
    show: boolean;
    onConfirm: () => void;
    onCancel: () => void;
}

export const ConfirmNavigationModal: React.FC<Props> = ({show, onConfirm, onCancel}) => {
    const {t} = useTranslation();

    return (
        <Modal
            show={show}
            onClose={onCancel}
            closable={false}
            hideCloseButton={true}
            modalWidth={0}
            title={t('pages.documents.invoices.confirmNavigationModal.title')}
        >
            <ModalContent>
                <ModalMessage>
                    {t('pages.documents.invoices.confirmNavigationModal.message')}
                </ModalMessage>
                <ModalButtons>
                    <Button variant={ButtonVariant.Outline} onClick={onConfirm}>
                        {t('pages.documents.invoices.confirmNavigationModal.confirm')}
                    </Button>
                    <Button variant={ButtonVariant.Normal} onClick={onCancel}>
                        {t('pages.documents.invoices.confirmNavigationModal.cancel')}
                    </Button>
                </ModalButtons>
            </ModalContent>
        </Modal>
    );
};
